import api from '../api';

export const path = '/bike/get';

export const getBikeTypeRequest = () => api.get(`${path}/type`);

export const getBikeMarkRequest = (type) =>
    api.get(`${path}/mark`, { params: { type } });

export const getBikeModelRequest = (params) =>
    api.get(`${path}/model`, { params });

export const getBikeBodyTypeRequest = (params) =>
    api.get(`${path}/bodyType`, { params });

export const getBikeModificationRequest = (params) =>
    api.get(`${path}/modification`, { params });

export const getBikeCharacteristicRequest = (params) =>
    api.get(`${path}/characteristic`, { params });

export const getBikeTechDataRequest = (params) => {
    return api.get(`${path}/techData`, {
        params: { params },
    });
};
